import type { PortalUser } from "@/app/models";
import { portalUserSchema } from "@/app/models";
import { parseResponseData, privateAPI } from "@/shared/lib";
import type { ISODate } from "@/shared/models/legacy-types";

export const getPortalUser = async () => {
  const response = await privateAPI.get(`/user`);

  return parseResponseData(response, portalUserSchema);
};
interface FillMissingInformationParams {
  dateOfBirth?: ISODate | null;
  gender?: PortalUser["gender"];
  heightFeet?: number;
  heightInches?: number;
  weightInPounds?: number;
}

export const fillMissingInformation = async (
  params: FillMissingInformationParams,
) => {
  return await privateAPI.put("/patients/fill-missing-information", params);
};
